"use client";
import { jsxs as m, jsx as a } from "react/jsx-runtime";
import { forwardRef as h, useState as v, useEffect as y } from "react";
import "axios";
import { parseClassNames as b } from "./index21.js";
const g = h(
  ({
    id: i,
    value: c = 1,
    minLimit: n = 0,
    limit: t = 99,
    name: d,
    onChange: u,
    disabled: r = !1,
    ...p
  }, f) => {
    const [e, l] = v(c);
    y(() => {
      l(c);
    }, [c]);
    const N = () => {
      l((o) => {
        const s = Math.min(o + 1, t);
        return u && u({
          target: {
            value: s.toString()
          }
        }), s;
      });
    }, x = () => {
      l((o) => {
        const s = Math.max(o - 1, n);
        return u && u({
          target: {
            value: s.toString()
          }
        }), s;
      });
    };
    return /* @__PURE__ */ m("div", { className: " numberbox-ui input-ui", children: [
      /* @__PURE__ */ m("div", { className: "numberbox-ui-container", children: [
        /* @__PURE__ */ a(
          "button",
          {
            className: b([
              "numberbox-ui-decrement",
              r || e <= n ? "limit" : ""
            ]),
            disabled: !!(r || e <= n),
            role: "button",
            type: "button",
            onClick: r || e <= n ? void 0 : x,
            children: /* @__PURE__ */ a("span", { className: "screen-readers-only", children: "Diminuir uma unidade" })
          }
        ),
        /* @__PURE__ */ a("div", { className: "numberbox-ui-display", children: e }),
        /* @__PURE__ */ a(
          "button",
          {
            className: b([
              "numberbox-ui-increment",
              r || e >= t ? "limit" : ""
            ]),
            disabled: !!(r || e >= t),
            role: "button",
            type: "button",
            onClick: r || e >= t ? void 0 : N,
            children: /* @__PURE__ */ a("span", { className: "screen-readers-only", children: "Adicionar uma unidade" })
          }
        )
      ] }),
      /* @__PURE__ */ m("label", { htmlFor: i, className: "screen-readers-only", children: [
        "Unidades:",
        /* @__PURE__ */ a(
          "input",
          {
            autoComplete: "off",
            type: "range",
            min: n,
            max: t,
            id: i,
            ref: f,
            name: d,
            ...p,
            disabled: r,
            value: e,
            onChange: (o) => l(Number(o.target.value))
          }
        )
      ] })
    ] });
  }
);
g.displayName = "Numberbox";
export {
  g as Numberbox
};
